import { ref } from "vue";
import { defineStore } from "pinia";

export const useDefaultStore = defineStore("default", () => {
  const appElement = ref(null);

  const setAppElement = (value) => {
    appElement.value = value;
  };
  const scrollToTop = () => {
    appElement.value.scrollIntoView({
      behavior: "smooth",
      inline: "start",
    });
  };
  return {
    setAppElement,
    scrollToTop,
    appElement,
  };
});
